<template>
  <div>
    <disqualification-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" @edit="edit"/>
    <disqualification-detail v-show="activeKey===2" ref="detail" :orderStatus="orderStatus" :type="type" @back="back"/>
  </div>
</template>

<script>
import DisqualificationList from '@/views/quality/disqualification/DisqualificationList.vue'
import DisqualificationDetail from '@/views/quality/disqualification/DisqualificationDetail.vue'

export default {
  name: 'DisqualificationTemplate',
  components: { DisqualificationList, DisqualificationDetail },
  data() {
    return {
      activeKey: 1
    }
  },
  props: {
    orderStatus: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.edit(row)
    }
  }
}
</script>